import React, { useEffect, useState } from 'react'
import {Link} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { updateUserStart } from '../redux/User/user.actions';
import { getUserOrderHistory } from './../redux/Orders/orders.actions';
import Button from './../components/forms/Button'
import DashAuthWrapper from './../components/DashAuthWrapper'
import db from "../../src/firebase/utils";

import Geocode from "react-geocode";
Geocode.setApiKey(process.env.REACT_APP_GEOCODE_KEY);

const mapState = ({ user, ordersData }) => ({
	currentUser: user.currentUser,
	orderHistory: ordersData.orderHistory.data
})

const Dashboard = props => {
	const { currentUser } = useSelector(mapState);
	const dispatch = useDispatch();

	const [displayName] = useState(currentUser.displayName);
	const [address] = useState(currentUser.address);
	const [address2] = useState(currentUser.address2);
	const [city] = useState(currentUser.city);
	const [state] = useState(currentUser.state);
	const [zip] = useState(currentUser.zip);
	const [phone] = useState(currentUser.phone);
	const [subscribed, setSubscribed] = useState(currentUser.subscribed);
	let [fullAddress] = useState(currentUser.fullAddress);
	const [center, setCenter] = useState(currentUser.center);
	const [EIN] = useState('NULL')
	const [contactName] = useState('NULL')
	const [contactEmail] = useState('NULL')
	

	useEffect(() => {
		
		window.scrollTo(0, 0)
		if(currentUser.center === 0){
			Geocode.fromAddress(currentUser.fullAddress).then(
				response =>
					{ 
						setCenter(response.results[0].geometry.location);
					}
			);
			dispatch(updateUserStart({
				EIN,
				contactName,
				contactEmail,
				displayName,
				address,
				address2,
				city,
				state,
				zip,
				phone,
				subscribed,
				fullAddress,
				center
				
			}))
		}
		dispatch(
			getUserOrderHistory(currentUser.id)
		);
		// eslint-disable-next-line
	}, [currentUser.center]); 

	

	useEffect(() => {
		db.collection("subscribers")
		  .doc(currentUser.id)
		  .collection("subscriptions")
		  .get()
		  .then((querySnapshot) => {
			querySnapshot.forEach(async (subscription) => {
				if(subscription.data().status === 'active'){
					setSubscribed(true); 
				}
			});
		});
	}, [currentUser.id])

	
	useEffect(()=>{
		dispatch(updateUserStart({
			EIN,
			contactName,
			contactEmail,
			displayName,
			address,
			address2,
			city,
			state,
			zip,
			phone,
			subscribed,
			fullAddress,
			center
			
		}))
		return;
		// eslint-disable-next-line
	}, [subscribed, center])
	
	console.log(currentUser.center)
	return (
		<div>
			{!currentUser.subscribed &&(
				<DashAuthWrapper >
					<h3 className="mt-5">You currently have no subscription</h3>
				
					<h3>Please 
						<Link to="/subscribe">
							<Button>
								SUBSCRIBE
							</Button>
						</Link>
						to be eligible for services
					</h3>
				</DashAuthWrapper>
			)}

			{currentUser.subscribed &&(
				<section className="dashPageMain d-flex align-items-center justify-content-center">
				<DashAuthWrapper>
					<h1 className="mainDashHeader">Welcome to Your Dashboard!</h1>

					
					{/* <div className="mt-5">
						<h3>
							Home Services
						</h3>

						<OrderHistory orders={orderHistory} />
					</div> */}
					<div className="mt-5" >
						<h2 className="text-white">
							What can we help you with?
						</h2>
						<div className="mt-3">
							<Link to="/services" className="mr-3">
								<Button className="btn btn-primary serviceBtn">
									Need an Add On?
								</Button>
							</Link>
						
							<Link to="/neededService">
								<Button className="btn btn-primary serviceBtn">
									Need a Quote?
								</Button>
							</Link>
						</div>
					</div>
				
				</DashAuthWrapper>
				</section>
			)}
		</div>	




		
	)
}

export default Dashboard;